import { render, staticRenderFns } from "./Decors.vue?vue&type=template&id=d57cc6c0&scoped=true"
import script from "./Decors.vue?vue&type=script&lang=js"
export * from "./Decors.vue?vue&type=script&lang=js"
import style0 from "./Decors.vue?vue&type=style&index=0&id=d57cc6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57cc6c0",
  null
  
)

export default component.exports